import { get, post } from "../../axios-interceptor-setup/apiService";

const BASE_URL = "/smart_city_pdl_tcu";

export const getPDLKpis = (body) => {
    return post(`${BASE_URL}/pdlcount`, {...body});
}

export const getLostPdlData = (body) => {
    return post(`${BASE_URL}/pdlcountbycity`, {...body});
}

export const getDepotWiseDataByCity = (body) => {
    return post(`${BASE_URL}/pdlcountbycitydepo`, {...body});
}

export const getCityDepotContract = (body) => {
    return post(`${BASE_URL}/location-filter`, {...body});
}

export const getDepotByCity = (body) => {
    return post(`${BASE_URL}/depot-filter`, {...body});
}

export const getVehiclesByDepot = (body) => {
    return post(`${BASE_URL}/table-vehicle-ageing`, {...body});
}

export const downloadPDLKpis = (api,body) => {
    return post(`${BASE_URL}/${api}`, {...body}, {
    responseType: "blob",
  });
}

export const downloadPDLVehicleData = (body) => {
    return post(`${BASE_URL}/download-vehicle-ageing`, {...body}, {
    responseType: "blob",
  });
}

export const getLastRefreshDate = () => {
    return post(`${BASE_URL}/last-refresh-date`, {});
}

export const loggingApiPDL = (body) => {
    return post(`/auth/logging`, {page_name: "PDL_BUS"});
}
